import * as React from "react";

import { Loader } from "@progress/kendo-react-indicators";
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { getter } from "@progress/kendo-react-common";

import {
    Grid,
    GridColumn,
    GridFilterChangeEvent,
    GridSelectionChangeEvent,
    getSelectedState,
} from "@progress/kendo-react-grid";

import {
    filterBy,
    CompositeFilterDescriptor,
} from "@progress/kendo-data-query";

import EventNew from "./EventNew";
import EventView from "./EventView";
import EventSummaryGrid from "./Reports/EventSummaryGrid";

import { useGetFollowUpsQuery } from '../store/sunbright-api';
import { useAppSelector } from "../store/store";

const DATA_ITEM_KEY = "uid";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

const EventsGrid = (props: any) => {
    const { data: followups, error: followupsError, isLoading: followupsLoading } = useGetFollowUpsQuery("");

    const [gridHeight, setGridHeight] = React.useState<string>("600px");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
    }, []);
    React.useEffect(() => {
        setGridHeight((window.innerHeight - 120) + "px");
   }, [followups]);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    const auth = useAppSelector((state) => state.auth);
    const role = (auth && (auth.user !== undefined) && auth.user.role) ? auth.user.role : "";

    const [newFollowUp, setNewFollowUp] = React.useState<boolean>(false);
    const [report, setReport] = React.useState<boolean>(false);

    const [filter, setFilter] = React.useState(initialFilter);

    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const [selectedUID, setSelectedUID] = React.useState<string>("");

    const handleSelectionChange = (e: GridSelectionChangeEvent) => {
        const newState = getSelectedState({
            event: e,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        })
        setSelectedState(newState);

        setSelectedUID(Object.keys(newState)[0]);
    };


    return (
        <React.Fragment>
            {(selectedUID.length !== 0) ?
                (< EventView
                    eventID={+selectedUID}
                    onReturn={() => setSelectedUID("")}
                />
                ) :
            (newFollowUp ?
                (<div>
                    <EventNew 
                        onReturn={(submitted: boolean) => setNewFollowUp(false)}
                    />
                </div>)
                :
                    (report ?
                        <EventSummaryGrid
                            returnLabel="Return to Events"
                            onReturn={() => setReport(false)}
                        />
                    :
                    <div>
                        <div className="sds-gridHeader">Events</div>
                        {followupsError ? (<>Not Authorized</>) : followupsLoading ? <Loader size="large" type="converging-spinner" /> : followups ? (
                        <div>
                            <div style={{ position: "fixed", top: "46px", right: "64px", zIndex: "99"  }}>
                                <ButtonGroup>
                                    <Button
                                        themeColor={"primary"}
                                        icon="plus-circle"
                                        style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                                       onClick={() => setNewFollowUp(true)}>
                                        New Event
                                    </Button>
                                    {((role.indexOf("Admin") !== -1) && (auth.user.region === 2)) && <Button
                                        themeColor={"primary"}
                                        icon="file-report"
                                        style={{ borderLeftColor: "white", borderLeftWidth: "1px" }}
                                        onClick={() => setReport(true)}>
                                        Report
                                    </Button>}
                               </ButtonGroup>
                            </div>

                        <Grid
                            style={{ height: gridHeight }}
                            className="eventsGrid sds-selectable"
                            // data={followups}
                            data={filterBy(followups.map((item: any) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)]
                                })), filter)}
                            sortable={true}
                            filterable={true}
                            filter={filter}
                            onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
                            resizable={true}
                            reorderable={true}
                            size={"small"}
                            dataItemKey={DATA_ITEM_KEY}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                mode: "single",
                            }}
                            onSelectionChange={handleSelectionChange}
                       >
                                    <GridColumn field="startTime" title="Date" format="{0:MMM d yyyy}" filterable={false} />
                            <GridColumn field="type" title="Type" filterable={true} filter="text" />
                            <GridColumn field="host" title="Host/Location" filterable={true} filter="text" />
                            <GridColumn field="region" title="Region" filterable={true} filter="text" />
                            </Grid>
                        </div>
                    ) : null}
                </div >
            ))}
        </React.Fragment>
    );
}
export default EventsGrid;
